import React, { FC, useEffect}                          				 from 'react';
import { useAuth0 }                                                      from '@auth0/auth0-react';


import { ScriptLoaderWithVisualBug, VendorLoaderProps } from './ScriptLoaderWithVisualBug';

const defaultProps: VendorLoaderProps = {
	id: null
}

const HubSpotAnalytics: FC<VendorLoaderProps> = ( { id, ...props } ) => {
	let { isLoading } = useAuth0();

	useEffect( () => {
		//@ts-ignore
		var _hsq = window._hsq;
		
		if(_hsq){
			_hsq.push(['trackPageView']);
		}
	});

	const initScript = () => {
		
		let script = document.createElement( 'script' );
		script.async = true;
		script.type  = 'text/javascript';
		script.id    = `hs-script-loader`;
		script.src   = `//js.hs-scripts.com/${ id }.js`;
		
		if( !document.getElementById( script.id ) ){
			document.getElementsByTagName( 'head' )[ 0 ].appendChild( script );
		}
		
	};
	
	return  isLoading ? null : ( id ? <ScriptLoaderWithVisualBug onLoad={ initScript } { ...props }/> : null );
}

HubSpotAnalytics.defaultProps = defaultProps;

export { HubSpotAnalytics }
